import { useEffect } from 'react';
import { useAuthContext } from '@/contexts/AuthContext';

export function useAuth() {
  const context = useAuthContext();
  return context;
}

export function useRequireAuth() {
  const { isAuthenticated, isInitialized, login } = useAuthContext();

  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      // Redirect to Keycloak login
      login();
    }
  }, [isAuthenticated, isInitialized, login]);

  return { isAuthenticated, isInitialized };
}

export function useRedirectIfAuthenticated() {
  // This is no longer needed since Keycloak handles the redirect
  // But we keep it for backward compatibility
  const { isAuthenticated, isInitialized } = useAuthContext();
  return { isAuthenticated, isInitialized };
}
